import React, {Fragment} from 'react';
import i18n from 'i18next';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link} from '@inertiajs/inertia-react';
import AbstractSignupArtwork from "@/Components/AbstractSignupArtwork";
import SetPasswordForm from "@/Pages/Auth/SetPasswordForm";
import ProductLogo from "@/Components/ProductLogo";
import usePasswordStateManager from "@/Hooks/usePasswordStateManager";
import {ApplicationViewType} from "@/Enums/ApplicationViewType";

export default function SetPassword() {
    const {data ,validationState, onChange, post, processing, errors}
        = usePasswordStateManager(ApplicationViewType.AUTH);

    const submit = (e) => {
        e.preventDefault();
        if(validationState.passwordIsValid)
        {
            post(route('password.set.store'));
        }
        e.preventDefault();
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <AbstractSignupArtwork/>
            <Head title="Set Password"/>
            <div className="set-password">
                <form onSubmit={submit}>
                    <ProductLogo />

                    {false && <ValidationErrors errors={errors}/>}
                    <Fragment>
                        <div data-testid="set_password-div-instructions" className="instructions">{i18n.t("set-password.set-password")}</div>
                        <SetPasswordForm errors={errors} data={data} onChange={onChange} state={validationState} />
                        <button
                            type="submit"
                            className="w-100 btn btn-primary"
                            data-testid="set_password-button-submit"
                            disabled={!validationState.passwordIsValid || processing}
                        >
                            {i18n.t("set-password.done")}
                        </button>
                        <a data-testid="set_password-link-back_to_login" href={route('logout')} className="link">
                            {i18n.t("set-password.back-to-login")}</a>
                    </Fragment>
                </form>
            </div>
        </Authenticated>
    );
}
